var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 7.5286L8.09755 5.43096C8.22772 5.30079 8.43878 5.30079 8.56895 5.43096C8.69913 5.56114 8.69913 5.77219 8.56895 5.90237L5.90229 8.56904C5.77211 8.69921 5.56106 8.69921 5.43088 8.56904L2.76422 5.90237C2.63404 5.77219 2.63404 5.56114 2.76422 5.43096C2.89439 5.30079 3.10545 5.30079 3.23562 5.43096L5.33325 7.5286L5.33325 0.333333C5.33325 0.149238 5.48249 0 5.66659 0C5.85068 0 5.99992 0.149238 5.99992 0.333333L5.99992 7.5286ZM10.6666 8.33333C10.6666 8.14924 10.8158 8 10.9999 8C11.184 8 11.3333 8.14924 11.3333 8.33333V10.3333C11.3333 11.2538 10.5871 12 9.66659 12H1.66659C0.746111 12 -8.10623e-05 11.2538 -8.10623e-05 10.3333V8.33333C-8.10623e-05 8.14924 0.149158 8 0.333253 8C0.517347 8 0.666586 8.14924 0.666586 8.33333V10.3333C0.666586 10.8856 1.1143 11.3333 1.66659 11.3333H9.66659C10.2189 11.3333 10.6666 10.8856 10.6666 10.3333V8.33333Z",
    fill: "#F5B309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.870cb9951a0877bd38257912b73acb2c.svg";
export { ForwardRef as ReactComponent };